import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
} from '@mui/material';
import React, { FC } from 'react';

import { AbgTypography, ArrowDownIcon } from '@abg/kit-base';

import { LocationHolidayHoursProps } from './location-details.types';
import { locationHolidayHoursStyles } from './LocationHolidayHours.styling';

export const LocationHolidayHours: FC<LocationHolidayHoursProps> = ({
  holidayHours,
  isExpanded,
  onToggle,
  title = 'Holiday Hours',
}) => {
  if (holidayHours.length === 0) {
    return null;
  }

  return (
    <Accordion
      expanded={isExpanded}
      onChange={(_, expanded) => onToggle(expanded)}
      sx={locationHolidayHoursStyles.accordion}
      data-testid="location-details-mobile-holidayHours-accordion"
    >
      <AccordionSummary expandIcon={<ArrowDownIcon />}>
        <AbgTypography
          variant="bodySmallMedium"
          sx={locationHolidayHoursStyles.titleTypography}
          data-testid="location-details-mobile-holidayHours-label"
        >
          {title}
        </AbgTypography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={0.5}>
          {holidayHours.map((entry, index) => (
            <Box
              key={`${entry.scheduleName}-${index}`}
              sx={locationHolidayHoursStyles.holidayRow}
              data-testid={`location-details-mobile-holidayHours-dayRow-${index}`}
            >
              <AbgTypography
                variant="bodySmallRegular"
                color="text.secondary"
                data-testid={`mobile-holidayHours-dayRow-${index}-label`}
              >
                {entry.scheduleName}
              </AbgTypography>
              <AbgTypography
                variant="bodySmallRegular"
                color="text.secondary"
                data-testid={`mobile-holidayHours-dayRow-${index}-date`}
              >
                {entry.date}
              </AbgTypography>
              <AbgTypography
                variant="bodySmallRegular"
                color="text.secondary"
                data-testid={`mobile-holidayHours-dayRow-${index}-status`}
              >
                {entry.status}
              </AbgTypography>
            </Box>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
